export type EnrichEntity = "request" | "intake" | "case" | "registration";

/**
 * Where each record opens. `{id}` is replaced with the record id.
 * ⚠️ `null` means "no link yet": the name stays plain text. Fill in the registration and intake
 * routes from your router (the same path their list pages navigate to when a row is clicked).
 */
const ROUTES: Record<EnrichEntity, string | null> = {
  request: "/Counselling/Requests/{id}",
  case: "/Counselling/Cases/{id}",
  registration: null, // e.g. "/Grow/Registrations/{id}"
  intake: null, //       e.g. "/Grow/Intakes/{id}"
};

export const recordPath = (entity: EnrichEntity, id: number): string | null =>
  ROUTES[entity]?.replace("{id}", String(id)) ?? null;
